// src/pages/EskiMusteriler.jsx
import { useState, useEffect } from 'react';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase/config';
import { Archive, Calendar, Search } from 'lucide-react';

export default function EskiMusteriler() {
  const [arşiv, setArşiv]   = useState([]);
  const [arama, setArama]   = useState('');

  useEffect(() => {
    const unsub = onSnapshot(
      query(collection(db, 'eskiMusteriler'), orderBy('silinmeTarihi', 'desc')),
      snap => setArşiv(snap.docs.map(d => ({ id: d.id, ...d.data() })))
    );
    return unsub;
  }, []);

  function tarihFormat(ts) {
    if (!ts) return '—';
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString('tr-TR', { day: '2-digit', month: 'long', year: 'numeric' });
  }

  const filtreli = arşiv.filter(m =>
    m.isimSoyisim?.toLowerCase().includes(arama.toLowerCase()) ||
    m.telefon?.includes(arama) ||
    m.isTanimi?.toLowerCase().includes(arama.toLowerCase())
  );

  return (
    <div className="max-w-2xl mx-auto px-6 py-8 space-y-6">
      <div className="flex items-center gap-2">
        <Archive size={18} className="text-stone-400" />
        <h1 className="text-lg font-semibold text-white">Eski Müşteriler</h1>
        <span className="text-xs text-stone-600 bg-stone-800 px-2 py-0.5 rounded-full">{arşiv.length}</span>
      </div>

      <p className="text-xs text-stone-600">
        Silinen müşterilerin temel bilgileri burada saklanır. Fotoğraf ve kayıtlar silinmiştir.
      </p>

      {/* Arama */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-600" size={14} />
        <input value={arama} onChange={e => setArama(e.target.value)}
          placeholder="İsim, telefon veya iş tanımı ara..."
          className="w-full bg-stone-900 border border-stone-800 text-white text-sm pl-9 pr-3 py-2.5 rounded-lg focus:outline-none focus:border-stone-600 placeholder-stone-600" />
      </div>

      {filtreli.length === 0 && (
        <div className="text-center text-stone-700 text-sm py-16 bg-stone-900 border border-stone-800 rounded-xl">
          {arama ? 'Sonuç bulunamadı' : 'Henüz arşivde kayıt yok'}
        </div>
      )}

      <div className="space-y-2">
        {filtreli.map(m => (
          <div key={m.id} className="bg-stone-900 border border-stone-800 rounded-xl px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-stone-800 flex items-center justify-center text-xs font-semibold text-stone-500">
                {m.isimSoyisim?.charAt(0).toUpperCase()}
              </div>
              <div>
                <div className="text-sm font-medium text-stone-300">{m.isimSoyisim}</div>
                <div className="text-xs text-stone-600">{m.isTanimi || '—'}</div>
                {m.telefon && <div className="text-xs text-stone-600">{m.telefon}</div>}
              </div>
            </div>
            <div className="text-right">
              <div className="flex items-center gap-1 text-xs text-stone-700">
                <Calendar size={10} /> {tarihFormat(m.silinmeTarihi)}
              </div>
              <div className="text-[10px] text-stone-700 mt-0.5">Silinme tarihi</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
